
import { useAdminSubscriptions } from "@/hooks/admin/useAdminSubscriptions";
import { useAccountPerformances } from "@/hooks/admin/useAccountPerformances";

export const usePerformanceData = (
  userRole: string | null, 
  providerId: string | null,
  setLoadingStripe: (loading: boolean) => void,
  setStripeSubscriptions: (subscriptions: any) => void
) => {
  // Subscriptions management
  const { fetchStripeSubscriptions } = useAdminSubscriptions(
    userRole, 
    setLoadingStripe, 
    setStripeSubscriptions
  );
  
  // Account performances management
  const { fetchAccountPerformances } = useAccountPerformances(userRole, providerId);

  return {
    fetchStripeSubscriptions,
    fetchAccountPerformances
  };
};
